// User widgets configuration for veterinarian and horseBreeder
// These widgets show process data filtered by processOwner

const processStages = {
    consultation_start: { 
        key: 'consultation_start', 
        name: '{{lang}}Start Consultation', 
        color: '#6366F1',
        // HERE WE NEED TO ADD EXTRA INFORMATION FOR USER TO SEE 
        // ASK WHAT HEADERS WE HAVE TO ADD!
        moreInfo:[],
        headers: [],
        // Widget visibility (status widgets)
        visibleFor: ['admin'],
        // Status editor visibility (ProfessionalStatusInput & TableProfessionalStatusInput)
        statusVisibleFor: ['admin'],
        // Who can advance process to next stage and see "Go to Next Stage" button
        advanceFor: ['admin']
    },
    stallion_selection: { 
        key: 'stallion_selection', 
        name: '{{lang}}Select Stallion', 
        color: '#8B5CF6',
        headers: [],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin']
    },
    financial_agreement: { 
        key: 'financial_agreement', 
        name: '{{lang}}Financial Agreement', 
        color: '#EC4899',
        headers: [
            { col: '6', type: 'FileInput', key: 'values.financialFile', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },

        ],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin']
    },
    mare_documents: { 
        key: 'mare_documents', 
        name: '{{lang}}Send Mare Documents', 
        color: '#F43F5E',
        headers: [],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin', 'horseBreeder'],
        advanceFor: ['admin']
    },
    upload_financial_docs: {
        key: 'upload_financial_docs',
        name: '{{lang}}Uploading financial docs',
        color: '#10B981',
        headers: [
            { col: '6', type: 'FileInput', key: 'values.financial_docsFile', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },

        ],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin']
    },
    financial_confirmation: {
        key: 'financial_confirmation',
        name: '{{lang}}Financial manager confirmation',
        color: '#059669',
        headers: [],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin'],
        // Only users with financials.edit can move process to this stage
        requiredPermission: 'admin.financials.edit'
    },
    mare_registration: { 
        key: 'mare_registration', 
        name: '{{lang}}Register Mare and Reserve Sperm', 
        color: '#14B8A6',
        headers: [],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin']
    },
    // New step: select veterinarian after mare_registration
    veterinarian_selection: {
        key: 'veterinarian_selection',
        name: '{{lang}}Select Veterinarian',
        color: '#0EA5E9',
        headers: [
            { 
                col: '12', 
                key: 'values.veterinarian', 
                type: 'SelectInput', 
                information: { 
                    label: '{{lang}}Veterinarian', 
                    updateAfterSelect: true, 
                    isSearchable: false, 
                    address: 'employeeGetAll', 
                    filter: { filter: { userType: 'veterinarian' } }, 
                    fields: { title: 'name', value: '_id' }, 
                    type: 'api', 
                    placeholder: '{{lang}}select', 
                    required: false, 
                    disabled: false 
                }, 
                showMain: true, 
                inExport: true 
            },
        ],
        visibleFor: ['admin'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin']
    },
    veterinarian_letter: { 
        key: 'veterinarian_letter', 
        name: '{{lang}}Send Veterinarian Letter', 
        color: '#06B6D4',
        headers: [
            { col: '6', type: 'FileInput', key: 'values.letterFile', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },

        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    coordination: { 
        key: 'coordination', 
        name: '{{lang}}Coordinate with Team', 
        color: '#3B82F6',
        headers: [],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    sperm_delivery: { 
        key: 'sperm_delivery', 
        name: '{{lang}}Deliver Sperm', 
        color: '#6366F1',
        headers: [
            { col: '3', key: 'values.firstPiot', type: 'TextInput', information: {  label: '{{lang}}first pilot',placeholder: '{{lang}}pilot code', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.firstDeliveryDate', type: 'DateInput', information: { label: '{{lang}}first delivery date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.firstPiotReciever', type: 'TextInput', information: {  label: '{{lang}}pilot reciever',placeholder: '{{lang}}pilot reciever', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.returnDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.secondPiot', type: 'TextInput', information: {  label: '{{lang}}second pilot',placeholder: '{{lang}}pilot code', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.secondDeliveryDate', type: 'DateInput', information: { label: '{{lang}}second delivery date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.secondPiotReciever', type: 'TextInput', information: {  label: '{{lang}}pilot reciever',placeholder: '{{lang}}pilot reciever', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.secondReturnDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.thirdPiot', type: 'TextInput', information: {  label: '{{lang}}third pilot',placeholder: '{{lang}}pilot code', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.thirdDeliveryDate', type: 'DateInput', information: { label: '{{lang}}third delivery date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.thirdPiotReciever', type: 'TextInput', information: {  label: '{{lang}}pilot reciever',placeholder: '{{lang}}pilot reciever', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.thirdReturnDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin', 'horseBreeder'],
        statusVisibleFor: ['admin'],
        advanceFor: ['admin']
    },
    sperm_receipt: { 
        key: 'sperm_receipt', 
        name: '{{lang}}Receive Sperm', 
        color: '#4F46E5',
        headers: [
            { col: '3', key: 'values.recvFirstPiot', type: 'TextInput', information: {  label: '{{lang}}first pilot',placeholder: '{{lang}}pilot code', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvFirstDeliveryDate', type: 'DateInput', information: { label: '{{lang}}first delivery date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvFirstPiotReciever', type: 'TextInput', information: {  label: '{{lang}}pilot reciever',placeholder: '{{lang}}pilot reciever', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvReturnDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvSecondPiot', type: 'TextInput', information: {  label: '{{lang}}second pilot',placeholder: '{{lang}}pilot code', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvSecondDeliveryDate', type: 'DateInput', information: { label: '{{lang}}second delivery date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvSecondPiotReciever', type: 'TextInput', information: {  label: '{{lang}}pilot reciever',placeholder: '{{lang}}pilot reciever', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvSecondReturnDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvThirdPiot', type: 'TextInput', information: {  label: '{{lang}}third pilot',placeholder: '{{lang}}pilot code', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvThirdDeliveryDate', type: 'DateInput', information: { label: '{{lang}}third delivery date', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvThirdPiotReciever', type: 'TextInput', information: {  label: '{{lang}}pilot reciever',placeholder: '{{lang}}pilot reciever', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '3', key: 'values.recvThirdReturnDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    insemination: { 
        key: 'insemination', 
        name: '{{lang}}Insemination by Doctor', 
        color: '#A855F7',
        headers: [
            { col: '6', type: 'FileInput', key: 'values.inseminationFile', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },

        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    return_piot: {
        key: 'return_piot',
        name: '{{lang}}Return Piot',
        color: '#9333EA',
        headers: [
            { col: '12', key: 'values.returnPiotDate', type: 'DateInput', information: { label: '{{lang}}return date', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    // day_15: { 
    //     key: 'day_15', 
    //     name: '{{lang}}15 Days After', 
    //     color: '#F59E0B',
    //     headers: [
    //         { col: '6', type: 'FileInput', key: 'values.day_15_file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },

    //     ],
    //     visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
    //     statusVisibleFor: ['admin', 'veterinarian'],
    //     advanceFor: ['admin', 'veterinarian']
    // },
    day_25: { 
        key: 'day_25', 
        name: '{{lang}}25 Days After', 
        color: '#EF4444',
        headers: [
            { col: '12', key: 'values.isPregnant', type: 'CheckboxInput', information: { label: '{{lang}}Is Pregnant', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '12', type: 'FileInput', key: 'values.day_25_file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    month_1: { 
        key: 'month_1', 
        name: '{{lang}}One Month', 
        color: '#F97316',
        headers: [
            { col: '12', type: 'FileInput', key: 'values.month_1_file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    month_3: { 
        key: 'month_3', 
        name: '{{lang}}Three Months', 
        color: '#F59E0B',
        headers: [
            { col: '12', type: 'FileInput', key: 'values.month_3_file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    month_6: { 
        key: 'month_6', 
        name: '{{lang}}Six Months', 
        color: '#EAB308',
        headers: [
            { col: '12', type: 'FileInput', key: 'values.month_6_file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    month_9: { 
        key: 'month_9', 
        name: '{{lang}}Nine Months', 
        color: '#84CC16',
        headers: [
            { col: '12', type: 'FileInput', key: 'values.month_9_file', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
   
    pregnancy_test: { 
        key: 'pregnancy_test', 
        name: '{{lang}}Pregnancy Test', 
        color: '#EAB308',
        headers: [
            { col: '6', key: 'values.pregnancyTest', type: 'SelectInput', information: { label: '{{lang}}Pregnancy Test', type: 'local', items: [{ value: 'سقط', title: 'سقط', color: '#fff', background: 'rgb(0, 122, 255)' }, { value: 'عدم سقط', title: 'عدم سقط', background: '#ee5050', color: '#fff' }], isSearchable: true, placeholder: '{{lang}}Select', required: false }, showMain: true, inExport: true },
            
        ],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    customer_care_1: { 
        key: 'customer_care_1', 
        name: '{{lang}}customer satisfaction1', 
        color: '#EAB308',
        headers: [],
        visibleFor: ['admin', 'veterinarian', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin']
    },
    customer_care_2: { 
        key: 'customer_care_2', 
        name: '{{lang}}customer satisfaction2', 
        color: '#EAB308',
        headers: [],
        visibleFor: ['admin', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
   
    receive_sheets: { 
        key: 'receive_sheets', 
        name: '{{lang}}Receive Sheets', 
        color: '#22C55E',
        headers: [
            { col: '12', type: 'FileInput', key: 'values.sheetsFile', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
            
        ],
        visibleFor: ['admin', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
    pedigree_letters: { 
        key: 'pedigree_letters', 
        name: '{{lang}}Prepare Pedigree Letters', 
        color: '#10B981',
        headers: [
            { col: '12', type: 'FileInput', key: 'values.pedigreeFile', col: '12', information: { label: 'آپلود فایل', single: true, cropper: true, ratio: '1:1', placeholder: '', required: false } },
            
        ],
        visibleFor: ['admin', 'horseBreeder'],
        statusVisibleFor: ['admin', 'veterinarian'],
        advanceFor: ['admin', 'veterinarian']
    },
}

// Widgets for Horse Breeder (customer)
const horseBreederWidgets = {
    ordersOverview: {
        key: 'ProcessStatusWidget',
        col: '12',
        title: '{{lang}}My Orders Overview',
        showOnlyHaveData: true,
        // permissionParent: 'user.orders',
        fetchUrl: 'getRecords',
        postBody: { frame: 'forms', processOwner: 'customer' },
        processStages: processStages,
    },
    // ordersByStage: {
    //     key: 'ProcessChartWidget',
    //     col: '6',
    //     title: '{{lang}}Orders by Process Stage',
    //     permissionParent: 'user.orders',
    //     fetchUrl: 'getRecords',
    //     postBody: { frame: 'forms', processOwner: 'customer' },
    //     processStages: processStages,
    //     chartType: 'pie',
    // },
    recentOrders: {
        key: 'TableWidget',
        col: '12',
        title: '{{lang}}Recent Orders',
        // permissionParent: 'user.orders',
        fetchUrl: 'getRecords',
        postBody: { frame: 'forms' },
        populates: [
            { key: 'veterinarian', model: 'employees', select: ['name'] },
            { key: 'customer', model: 'employees', select: ['name'] },
        ],
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.veterinarian', type: 'SelectInput', information: { label: '{{lang}}Veterinarian', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.customer', type: 'SelectInput', information: { label: '{{lang}}Customer', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
        actions: {
            view: { key: "view", label: "{{lang}}view", color: '#10453d', bgColor: '#10453d', function: "openViewModal", permission: 'view' },
        },
    },
}

// Widgets for Veterinarian
const veterinarianWidgets = {
    operationsOverview: {
        key: 'ProcessStatusWidget',
        page: 'forms',
        col: '12',
        title: '{{lang}}My Operations Overview',
        fetchUrl: 'getUserRecords',
        self:'veterinarian',
        postBody: { frame: 'forms' },
        processStages: processStages,
    },
    // operationsByStage: {
    //     key: 'ProcessChartWidget',
    //     col: '6',
    //     title: '{{lang}}Operations by Process Stage',
    //     permissionParent: 'user.operations',
    //     fetchUrl: 'getRecords',
    //     postBody: { frame: 'forms'},
    //     processStages: processStages,
    //     chartType: 'pie',
    // },
    recentOperations: {
        key: 'TableWidget',
        col: '12',
        page: 'forms',
        title: '{{lang}}Recent Operations',
        fetchUrl: 'getUserRecords',
        postBody: { frame: 'forms'},
        self:'veterinarian',
        populates: [
            { key: 'values.modelMale', model: 'records', select: ['values.name','values.faName'] },
            { key: 'values.veterinarian', model: 'employees', select: ['name'] },
            { key: 'values.customer', model: 'employees', select: ['name'] },
        ],
        actions: {
            seeStatus: { key: "seeStatus", label: '{{lang}}See Orders Status', color: '#fff', function: "openStatusModal", permission: '' },
        },
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'DateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.address', type: 'TextInput', information: { label: '{{lang}}Address', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'TextInput', information: { section: 'female', label: '{{lang}}model', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.modelMale', type: 'SelectInput', information: { disabled: true,dontShowExtraValue:true, section: 'male', label: '{{lang}}model Male', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'horses' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name',description:'values.faName', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false },
           
            showMain: true, inExport: true },
            { col: '6', key: 'values.modelMaleDesc', type: 'TextInput', information: { disabled: true, section: 'male', label: '{{lang}}Model Male Description', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.microChipNumberMale', type: 'TextInput', information: {  disabled: true,section: 'male', label: '{{lang}}Micro Chip Number Male', required: false }, showMain: true, inExport: true },

            // { col: '6', key: 'values.veterinarian', type: 'SelectInput', information: { label: '{{lang}}Veterinarian', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            // { col: '6', key: 'values.customer', type: 'SelectInput', information: { label: '{{lang}}Customer', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
      
    },
}

// Function to get widgets based on user type
export function getUserWidgets(userType) {
    if (userType === 'veterinarian') {
        return veterinarianWidgets
    } else if (userType === 'horseBreeder') {
        return horseBreederWidgets
    }
    return {}
}

export { horseBreederWidgets, veterinarianWidgets, processStages }
